import axios from '@/utils/axiosHelper'

// 初始化
export const onInitAPI = (params) => {
    return axios({ url: '/snail/blind/index', method: 'GET', params }, { interceptResultCode: false })
}

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: '/game/my/disable', method: 'POST', params }, { interceptResultCode: false })
}

// npc消息获取
export const onPushAPI = (params) => {
    return axios({ url: '/snail/blind/push', method: 'POST', params }, { interceptResultCode: false })
}

// 嘉宾消息发送
export const onGuestAPI = (params) => {
    return axios({ url: '/snail/blind/guest', method: 'POST', params }, { interceptResultCode: false })
}

// 进入聊天页面
export const onEnterAPI = (params) => {
    return axios({ url: '/snail/blind/lssued', method: 'POST', params }, { interceptResultCode: false })
}

// 赠送礼物
export const onGiftAPI = (params) => {
    return axios({ url: '/snail/blind/gift', method: 'POST', params }, { interceptResultCode: false })
}

// 拉黑
export const onBlackAPI = (params) => {
    return axios({ url: '/snail/blind/black', method: 'POST', params }, { interceptResultCode: false })
}

// 邀请
export const onInviteAPI = (params) => {
    return axios({ url: '/snail/blind/invit', method: 'POST', params }, { interceptResultCode: false })
}

// 领取奖励
export const onRewardAPI = (params) => {
    return axios({ url: '/snail/blind/reward', method: 'POST', params }, { interceptResultCode: false })
}

// 音乐开关
export const onClickAPI = (params) => {
    return axios({ url: '/snail/blind/click', method: 'POST', params }, { interceptResultCode: false })
}

// 是否为新用户
export const onGuideAPI = (params) => {
    return axios({ url: '/snail/blind/guide', method: 'GET', params }, { interceptResultCode: false })
}


// WEBPACK FOOTER //
// ./src/pages/snail/assignation/api.js